export default __webpack_public_path__ + "static/media/logo-xl-1440w.324d9caf.png";